import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrincipalLayoutComponent } from '../../layout/principal-layout/principal-layout.component';
import { NoticiasAltaComponent } from './noticias-alta.component';
import { AuthGuardService } from 'src/app/services/auth-guard.service';

const routes: Routes = [
  {
    path: 'noticias-alta',
    component: PrincipalLayoutComponent,
    // canActivate: [AuthGuardService],
    children: [
      { path: '', component: NoticiasAltaComponent },
    ]
  },
  {
    path: 'noticias-alta/:id',
    component: PrincipalLayoutComponent,
    // canActivate: [AuthGuardService],
    children: [
      { path: '', component: NoticiasAltaComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NoticiasRoutingModule { }
